__turbopack_context__.v({
  "className": "-Le6sq_className",
  "variable": "-Le6sq_variable",
});
